import logo from "assets/img/logo/logo_aig_login-2.png";
import PropTypes from "prop-types";
import React from "react";
import { Input, Button, Label, Alert, Col, Row } from "reactstrap";
import { BrowserRouter as Router, Route, Link, withRouter} from "react-router-dom";
import { connect } from "react-redux";
import { required, email } from "../../utils/validaciones";
//import Input from "react-validation/build/input";
import linea from "assets/img/login/linea.png";
import Form from "react-validation/build/form";
import { Textbox } from "react-inputs-validation";
import "react-inputs-validation/lib/react-inputs-validation.min.css";
import { isStyledComponent } from "styled-components";
import { validarUsuariosOkta } from "../../redux/actions/aLogin";
import { urlRedireccionLogin } from "../../constants/urls";

//import Button from "react-validation/build/button";

class AuthForm extends React.Component {
  get isLogin() {
    return this.props.authState === STATE_LOGIN;
  }
  constructor(props) {
    super(props);

    // eslint-disable-next-line no-undef
    this.state = {
      name: "",
      contrasenia: "",
      hasUserError: true,
      hasContrasenaError: true,
      validate: false,
      blur: false,
      // valida si es que el usuario requiere OKTA o no
      validarUsuarioOkta: true
    };
    this.validateForm = this.validateForm.bind(this);
    //this.textInput = React.createRef();
  
  }

  toggleValidating(validate) {
    this.setState({ validate });
  }
  async validateForm(e) {
    e.preventDefault();
    this.toggleValidating(true);
    const {
      name,
      contrasenia,
      // job,
      // country,
      // agreement,
      // description,
      hasUserError,
      hasContrasenaError,
      validarUsuarioOkta
    } = this.state;

    // verificar si es usuario OKTA
    // los usuarios OKTA, se registran externamente
    if( validarUsuarioOkta ){
      // llamar servicio y guardar respuesta
      await this.props.validarUsuariosOkta({email: name});

      // si es que si es OKTA redirigir
      if( this.props.respuestaOkta.autenticarOkta ){
        window.location.assign(urlRedireccionLogin);
      }
      // si es que no es OKTA, cambiar estado para registro normal
     
        this.setState({ validarUsuarioOkta:false })
      
    }
    // en caso de que no sea usuario OKTA
    else {
      //console.log("All validated!", this.state, this.state.name.length, this.state.contrasenia.length);
      //console.log(this.props);
      if ((hasUserError === false && hasContrasenaError === false) || (this.state.name.length !== 0 && this.state.contrasenia.length !== 0)) {
        this.props.onSelectIniciarSesion({
          correo: name,
          contrasenia: contrasenia
        });
        //this.props.onClickRecuperar({correo:name})
        //console.log("All validated!");
      }
    }
  }

  
  // changeAuthState = authState => event => {
  //   event.preventDefault();

  //   this.props.onChangeAuthState(authState);
  // };

  // handleSubmit = event => {
  //   event.preventDefault();
  // };
  // componentDidMount() {
  //   console.log(this.textInput.value);
  // }

  // focusTextInput() {
  //   // Explicitly focus the text input using the raw DOM API
  //   // Note: we're accessing "current" to get the DOM node
  // }
  render() {
    const {
      showLogo,
      onChangeFormulario,
      datosUsuario,
      usr,
      vacios
    } = this.props;

    const { validate, blur, name, contrasenia, validarUsuarioOkta } = this.state;

    let mensajeError = 'No se pudo procesar su solicitud. Por favor intente más tarde';
    if (datosUsuario.dataUsuario && datosUsuario.dataUsuario.errorDescripcion !== undefined && datosUsuario.errorDescripcion !== null) {
      mensajeError = `No se pudo procesar su solicitud. ${datosUsuario.dataUsuario.errorDescripcion}. Por favor intente más tarde`;
    }
    return (
        <form onSubmit={this.validateForm}>
            {/* {showLogo && (
                  <div className="text-center pb-4">
                    <Link to={`/`}>
                      <img
                        src={logo}
                        className="login-logo"
                        style={{ cursor: "pointer" }}
                        alt="logo"
                      />
                    </Link>
                  </div>
                )} */}
            <div>
              <strong style={{ color: "#001871", }}>BIENVENIDO</strong>
              <div style={{ textAlign: "justify", }}>Ahora puedes acceder al sistema con las siguientes credenciales:</div>
              <img alt='' src={linea} className={"img-login-interfaz"} />
            </div>
            <div className="form-group">
              <Label for="Correo Electrónico" className={"input-label-login"}>Usuario</Label>
              <Textbox
              // ref={this.textInput}
                tabIndex="1"
                type="email"
                id="Inputcorreo"
                name="Inputcorreo"
                placeholder="jperez@email.com"
                value={name}
                onChange={(name, e) => {
                  this.setState({ name: name });
                  //onChangeFormulario(e)
                }}
                classNameInput="form-control"
                validate={validate}
                validationCallback={res =>
                  //console.log(res)
                  this.setState({ hasUserError: res, validate: false })
                } // Optional.[Func].Default: none. Return the validation result.
                onBlur={e => {
                  this.setState({ blur: true });
                  //console.log(e);
                }} // Optional.[Func].Default: none. In order to validate the value on blur, you MUST provide a function, even if it is an empty function. Missing this, the validation on blur will not work.
                onFocus={e => {
                  //console.log(e);
                }} // Optional.[Func].Default: none.
                // onClick={(e) => {console.log(e);}} // Optional.[Func].Default: none.
                validationOption={{
                  name: "Inputcorreo", // Optional.[String].Default: "". To display in the Error message. i.e Please enter your ${name}.
                  check: true, // Optional.[Bool].Default: true. To determin if you need to validate.

                  msgOnError: "Por favor ingrese un correo electrónico válido",
                  customFunc: email => {
                    // eslint-disable-next-line no-useless-escape
                    const reg = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                    if (reg.test(String(email).toLowerCase())) {

                      return true;
                    } else {
                      this.setState({ hasUserError: true, validate: false })
                      return "no es un correo electrónico válido";
                    }
                  } // Optional.[Bool].Default: true. To determin if it is a required field.

                  // type: 'string', // Optional.[String].Default: "string". Validation type, options are ['string', 'number'].
                  // showMsg: true, // Optional.[Bool].Default: true. To determin display the error message or not.
                  // min: 2, // Optional.[Number].Default: 0. Validation of min length when validationOption['type'] is string, min amount when validationOption['type'] is number.
                  // max: 10, // Optional.[Number].Default: 0. Validation of max length when validationOption['type'] is string, max amount when validationOption['type'] is number.
                  // length: 2, // Optional.[Number].Default: 0. Validation of exact length of the value.
                  // compare: '3', // Optional.[String].Default: "" Compare this value to 3 to see if they are equal.
                  // reg: /^\d{18}|\d{15}$/, // Optional.[Bool].Default: "" Custom regex.
                  // regMsg: 'failed in reg.test(${value})', // Optional.[String].Default: "" Custom regex error message.
                  // locale: 'en-US', // Optional.[String].Default: "en-US". For error message display. Current options are ['zh-CN', 'en-US']; Default is 'en-US'.
                  // msgOnError: "Your custom error message if you provide the validationOption['msgOnError']", // Optional.[String].Default: "" Show your custom error message no matter what when it has error if it is provied.
                  // msgOnSuccess: "Your custom success message if you provide the validationOption['msgOnSuccess']. Otherwise, it will not show, not even green border." // Optional.[String].Default: "". Show your custom success message no matter what when it has error if it is provied.
                  // customFunc: res => { // Optional.[Func].Default: none. Custom function. Returns true or err message
                  //   if (res != 'milk') {
                  //     return 'Name cannot be other things but milk';
                  //   }
                  //   return true;
                  // }
                }}
              />
            </div>
            {!validarUsuarioOkta && (
                <>
                    <Label for="Contraseña" className={"input-label-login"}>Contraseña</Label>
                    <Textbox
                      type="password"
                      id="Inputcontrasena"
                      name="Inputcontrasena"
                      placeholder="Contraseña"
                      onChange={(contrasenia, e) => {
                        this.setState({ contrasenia: contrasenia });
                        // onChangeFormulario(e)
                      }}
                      validate={validate}
                      validationCallback={res =>
                        //console.log(res)
                        //hasContrasenaError= res
                        this.setState({ hasContrasenaError: res, validate: false })
                      }
                      value={contrasenia}
                      classNameInput={"form-control"}
                      onBlur={e => {
                        this.setState({ blur: true });
                        //console.log(e);
                      }} // Optional.[Func].Default: none. In order to validate the value on blur, you MUST provide a function, even if it is an empty function. Missing this, the validation on blur will not work.
                      // onFocus={(e) => {console.log(e);}} // Optional.[Func].Default: none.
                      // onClick={(e) => {console.log(e);}} // Optional.[Func].Default: none.
                      validationOption={{
                        name: "Inputcontrasena", // Optional.[String].Default: "". To display in the Error message. i.e Please enter your ${name}.
                        check: true, // Optional.[Bool].Default: true. To determin if you need to validate.
                        required: true,
                        msgOnError: "Por favor ingrese su contraseña" // Optional.[Bool].Default: true. To determin if it is a required field.
                        // type: 'string', // Optional.[String].Default: "string". Validation type, options are ['string', 'number'].
                        // showMsg: true, // Optional.[Bool].Default: true. To determin display the error message or not.
                        // min: 2, // Optional.[Number].Default: 0. Validation of min length when validationOption['type'] is string, min amount when validationOption['type'] is number.
                        // max: 10, // Optional.[Number].Default: 0. Validation of max length when validationOption['type'] is string, max amount when validationOption['type'] is number.
                        // length: 2, // Optional.[Number].Default: 0. Validation of exact length of the value.
                        // compare: '3', // Optional.[String].Default: "" Compare this value to 3 to see if they are equal.
                        // reg: /^\d{18}|\d{15}$/, // Optional.[Bool].Default: "" Custom regex.
                        // regMsg: 'failed in reg.test(${value})', // Optional.[String].Default: "" Custom regex error message.
                        // locale: 'en-US', // Optional.[String].Default: "en-US". For error message display. Current options are ['zh-CN', 'en-US']; Default is 'en-US'.
                        // msgOnError: "Your custom error message if you provide the validationOption['msgOnError']", // Optional.[String].Default: "" Show your custom error message no matter what when it has error if it is provied.
                        // msgOnSuccess: "Your custom success message if you provide the validationOption['msgOnSuccess']. Otherwise, it will not show, not even green border." // Optional.[String].Default: "". Show your custom success message no matter what when it has error if it is provied.
                        // customFunc: res => { // Optional.[Func].Default: none. Custom function. Returns true or err message
                        //   if (res != 'milk') {
                        //     return 'Name cannot be other things but milk';
                        //   }
                        //   return true;
                        // }
                      }}
                    />
                    <Row>
                      <Col lg={6} md={6} sm={12} xs={12} ></Col>
                      <Col lg={6} md={6} sm={12} xs={12} >
                        <div className="text-center pt-1" >
                          <Link to={`/recuperar-contrasenia`} className={"btn-color-main"} style={{ fontSize: "14px" }}>¿Olvidó su Contraseña?</Link>
                        </div>
                      </Col>
                    </Row>
                </>
            )}

            <Row>
              <Col xs={6} style={{ display: "block", margin: "auto" }}>
                <p></p>
                <Button
                  size="lg"
                  type="submit"
                  className="bg-gradient-theme-left border-0 border-redondeados-login"
                  block
                  onClick={this.validateForm}
                  style={{ borderRadius: "30px", fontSize: "14px" }}
                > INGRESAR </Button>

              </Col>
            </Row>
            <Row>
              <Col lg={12} md={12} sm={12} xs={12} >
                <div className="text-center pt-1">
                  <h6>
                    <Link to={`/`} className={"btn-color-main"} style={{ fontSize: "16px"}} >Ir a Inicio</Link>
                  </h6>
                </div>
              </Col>
            </Row>
            <Row>
              <Col lg={12} md={12} sm={12} xs={12} style={{ display: "block", margin: "auto" }}>
                {datosUsuario.loginHasError && (
                  <Alert color="warning">
                    <center>
                      <p>
                        {mensajeError}
                      </p>
                    </center>
                  </Alert>
                )}
              </Col>
            </Row>
        </form>
    );
  }
}

export const STATE_LOGIN = "LOGIN";

AuthForm.propTypes = {
  authState: PropTypes.oneOf([STATE_LOGIN]).isRequired,
  onSelectIniciarSesion: PropTypes.func.isRequired,
  showLogo: PropTypes.bool
};

AuthForm.defaultProps = {
  authState: "LOGIN",
  showLogo: true
};


// Map state to props
const mapStateToProps = state => ({
  respuestaOkta: state.rUsuariosOkta
});

// Map dispatch to props
const mapDispatchToProps = dispatch => {
  return {
    validarUsuariosOkta: email => dispatch(validarUsuariosOkta(email))
  };
};

// Export with router, para redux
export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(AuthForm)
);